// Persisted user preference for TTS playback speed across the app.
// Range: 0.5×–1.5× in 0.25 steps. Default 1.0×.

const KEY = "tiplingo_tts_speed_v1";

export const TTS_SPEED_OPTIONS = [
  { value: 0.5, label: "0.5×", description: "Very slow" },
  { value: 0.75, label: "0.75×", description: "Slow" },
  { value: 1.0, label: "1.0×", description: "Normal" },
  { value: 1.25, label: "1.25×", description: "Fast" },
  { value: 1.5, label: "1.5×", description: "Very fast" },
];

export function getTtsSpeed() {
  try {
    const raw = localStorage.getItem(KEY);
    const n = parseFloat(raw);
    if (Number.isFinite(n) && n >= 0.5 && n <= 1.5) return n;
  } catch {
    /* localStorage unavailable */
  }
  return 1.0;
}

export function setTtsSpeed(value) {
  try {
    localStorage.setItem(KEY, String(value));
  } catch {
    /* localStorage unavailable */
  }
}

export function getTtsSpeedLabel(value) {
  const match = TTS_SPEED_OPTIONS.find((o) => o.value === value);
  return match ? match.label : `${value}×`;
}
